import { baseApi } from "./baseApi";
import { accountUserResponse, PayloadAccountPatch, Response } from "src/types";

const accountApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCuentasById: build.query<accountUserResponse, { id: string }>({
      query: ({ id }) => ({
        url: `cuentas/${id}`,
        method: "GET",
      }),
    }),
    patchCuenta: build.mutation<Response, { accountId: string; body: PayloadAccountPatch }>({
      query: ({ accountId, body }) => ({
        url: `cuentas/${accountId}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const { useLazyGetCuentasByIdQuery, usePatchCuentaMutation } = accountApi;
